export const WIDGET_VERSION = '1.8.9';
export const getCopyrightYear = () => new Date().getFullYear();
export const COPYRIGHT_TEXT = `© ${getCopyrightYear()} Anton Fredriksson (Silver). All rights reserved.`;
